export default __webpack_public_path__ + "media/images/refresh-3cb6476b0e0954031087614d9a928899.png";